// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + ".main-" + {"102":"c16de4","657":"c935cf","779":"e4f525"}[chunkId] + ".css";
};